module.exports = __webpack_public_path__ + "static/media/map-arcade.a921dd82.png";